'use strict';

import type { IndPlanYearReview } from '../../Entities/Ind/IndPlanYearReview';
import { EntityCollection } from '../EntityCollection';

export class IndPlanYearReviewCollection extends EntityCollection<IndPlanYearReview> {}
